import React, { useEffect, useRef } from "react";

/**
 * Wraps the public/assets/vitura-logo.js drop-in script.
 * The script auto-initializes on DOMContentLoaded (initAll()) and is idempotent
 * on already-mounted hosts via host.dataset.viturInit. To make it re-run on
 * SPA mounts, we re-inject the script tag on each mount of this component.
 */
export default function VituraAnimatedLogo({
  color = "#0a0a0a",
  width = 220,
  className = "",
  testId = "vitura-animated-logo",
}) {
  const hostRef = useRef(null);

  useEffect(() => {
    // Re-execute the IIFE so its initAll() picks up our new host node.
    const s = document.createElement("script");
    s.src = "/assets/vitura-logo.js";
    s.async = true;
    document.body.appendChild(s);
    return () => {
      s.remove();
    };
  }, []);

  return (
    <div
      ref={hostRef}
      className={`vitura-logo ${className}`}
      data-color={color}
      style={{ width }}
      data-testid={testId}
    />
  );
}
